export const DEFERRED_LOADING_TIMEOUT_RENDERING = 400;
export const DEFERRED_LOADING_TIMEOUT = 200;